export function toInAppPathFromLaunchUrl(targetURL: string, origin: string): string | null {
  let url: URL;
  try {
    url = new URL(targetURL, origin);
  } catch {
    return null;
  }
  if (url.origin !== origin) {
    return null;
  }
  return `${url.pathname}${url.search}${url.hash}`;
}

export function isPwaDeepLinkPath(path: string): boolean {
  let url: URL;
  try {
    url = new URL(path, 'https://scribane.invalid');
  } catch {
    return false;
  }
  return url.pathname !== '/' && url.pathname !== '';
}

type LaunchListener = (path: string) => void;

let pendingLaunchPath: string | null = null;
const listeners = new Set<LaunchListener>();

type LaunchQueueWindow = Window & {
  launchQueue?: {
    setConsumer: (consumer: (params: { targetURL?: string }) => void) => void;
  };
};

export function peekPwaLaunchPath(): string | null {
  if (pendingLaunchPath && isPwaDeepLinkPath(pendingLaunchPath)) {
    return pendingLaunchPath;
  }
  return null;
}

export function clearPwaLaunchPathIfMatches(currentPath: string): void {
  if (pendingLaunchPath === currentPath) {
    pendingLaunchPath = null;
  }
}

export function subscribeToPwaLaunch(listener: LaunchListener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

export function setPendingPwaLaunchPath(path: string): void {
  pendingLaunchPath = path;
  listeners.forEach((listener) => listener(path));
}

export function installPwaLaunchConsumer(): void {
  const launchQueue = (window as LaunchQueueWindow).launchQueue;
  if (!launchQueue) {
    return;
  }
  launchQueue.setConsumer((launchParams) => {
    if (!launchParams.targetURL) {
      return;
    }
    const path = toInAppPathFromLaunchUrl(launchParams.targetURL, window.location.origin);
    if (!path || !isPwaDeepLinkPath(path)) {
      return;
    }
    setPendingPwaLaunchPath(path);
  });
}

export function resetPwaLaunchState(): void {
  pendingLaunchPath = null;
  listeners.clear();
}
